import type { ReactNode } from "react";
import { createContext, useContext } from "react";

type ContextValue = {
  enabled: boolean;
};

const SimpleSnackbarContext = createContext<ContextValue>({
  enabled: true,
});

type Props = ContextValue & {
  children: ReactNode;
};

export const SimpleSnackbarContextProvider: React.FunctionComponent<Props> = ({
  children,
  ...value
}) => <SimpleSnackbarContext.Provider value={value}>{children}</SimpleSnackbarContext.Provider>;

SimpleSnackbarContextProvider.displayName = "SimpleSnackbarContextProvider";

export const useSimpleSnackbarContext = () => useContext(SimpleSnackbarContext);
